import * as React from 'react';

function KeyIcon({ width = 16, height = 16, color = '#545454', ...props }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 24 24'
			fill='none'
			{...props}
		>
			<path
				d='M15.5 7.5l2.3 2.3a1 1 0 001.4 0l2.1-2.1a1 1 0 000-1.4L19 4m2-2l-9.6 9.6m1.6 3.9a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default KeyIcon;
